<template>
  <v-card elevation="0">
    <app-menu
      :menus="menus"
      :homeUrl="homeUrl"
      :profileRouter="'adm-profile'"
      :helpRouter="'adm-help'"
    ></app-menu>
    <router-view name="content" class="container-principal"></router-view>
  </v-card>
</template>

<script>
import Footer from '../shared/UserFooter.vue';
// import Navbar from "../shared/UserNavbar.vue";
import MenuModel from '../../models/Menu.js';
import Menu from '../shared/Menu.vue';

export default {
  data: function() {
    return {
      homeUrl: '/adm/reservas',
      type_client: localStorage.getItem('type_client'),
    };
  },
  computed: {
    menus() {
      return [
        this.type_client != 'concessionaria'
          ? new MenuModel('Dashboard', 'dashboard', 'adm-home')
          : new MenuModel('Dashboard', 'dashboard', 'adm-create-request'),

        new MenuModel('Usuários', 'mdi-account-multiple', 'cadastrar', [
          new MenuModel('Cadastro', 'nc-icon nc-single-02', 'driver'),
          new MenuModel('Aprovação', 'nc-icon nc-single-02', 'aprovar-usuario'),
        ]),

        new MenuModel('Relatórios', 'assignment', 'relatorio', [
          new MenuModel('Reservas', 'nc-icon nc-single-02', 'adm-services'),
          new MenuModel(
            'Solicitação de Reserva',
            'nc-icon nc-single-02',
            'solicitacao-reserva'
          ),
          new MenuModel(
            'Feedback',
            'nc-icon nc-single-02',
            'relatorio-feedback'
          ),
        ]),
      ];
    },
  },

  components: {
    'app-footer': Footer,
    // "app-nav": Navbar,
    'app-menu': Menu,
  },
};
</script>
